(() => {
  const sections = document.querySelectorAll('.index-text-products');

  const sectionObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      } else {
        entry.target.classList.remove('visible');
      }
    });
  }, {
    threshold: 1,
  });

  sections.forEach((section) => {
    const circle = section.querySelector('.flip');
    sectionObserver.observe(circle);
  });
})();
